import React, { useCallback } from 'react';
import { Box } from '@common-fe/common-fe';

import { LockboxCheckType } from '@/modules/employer/components/Lockbox/lockbox.types';
import { MatchingListWrapper } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import ChecksSearch from './ChecksSearch';
import SuggestedChecks from './SuggestedChecks';

const SelectChecks = () => {
  const { editableLockbox, setEditableLockbox } = useLockboxDetailsStore();
  const selectedCheckId = editableLockbox?.selectedCheckId;

  const handleSelectCheck = useCallback(
    (checkId?: string, checkType?: LockboxCheckType) => {
      setEditableLockbox({
        selectedCheckId: checkId,
        selectedCheckType: checkType,
      });
    },
    [setEditableLockbox]
  );

  return (
    <MatchingListWrapper title="Check">
      <SuggestedChecks
        selectedCheckId={selectedCheckId}
        onSelectCheck={handleSelectCheck}
      />
      <Box margin={{ top: 'spacing24' }}>
        <ChecksSearch
          selectedCheckId={selectedCheckId}
          onSelectCheck={handleSelectCheck}
        />
      </Box>
    </MatchingListWrapper>
  );
};

export default SelectChecks;
